export default {
  getContractFile: (state) => state.contractFile,
};
